import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';

// TODO: [+graphql-tag/loader] Think of way to use .graphql extension and query string instead of gql.
export var inviteFriendQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query inviteFriend($consultant: Int!) {\n    inviteFriendProfile(consultantNumber: $consultant) {\n      firstName\n      lastName\n      photoUrl\n    }\n  }\n"])));